export const columns = [
  {
    Header: 'Titulo',
    accessor: 'title',
  },
  {
    Header: 'Contenido',
    accessor: 'description',
  },
  {
    Header: 'Nivel',
    accessor: 'category',
  },
  {
    Header: 'Imagen',
    accessor: 'image',
  },
  {
    Header: 'Enlace',
    accessor: 'url',
  },
  {
    Header: 'Editar',
    accessor: 'editGrowthPath',
  },
  {
    Header: 'Eliminar',
    accessor: 'deleteGrowthPath',
  },
  {
    Header: 'Estado',
    accessor: 'active',
  },
]
